import React, {useEffect, useRef, useState} from "react";
import "./Festival.scss";
import Swiper from "swiper";
import 'swiper/swiper-bundle.min.css'
import {useHistory, useLocation} from "react-router-dom";
import {Nav} from "../../Components";
import {FestivalData} from "./FestivalServices";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import {useResp} from "../../hooks";
import CampaignDesktop from "../CampaignDesktop/CampaignDesktop";

function Festival() {

    //hooks
    const history = useHistory();
    const location = useLocation()

    //states
    const [festivals,setFestivals] = useState(null);
    const [preload, setPreload] = useState(true);
    const [failed, setFailed] = useState(false);

    // TSliderDesktop Functions -------------------------------------
    const swiper = useRef(null)
    const Loop = ()=>{
        setInterval(()=>{
            swiper.current.slideNext();
        },2000)
    }

    const [nav_label,set_nav_label] = useState(null)

    useEffect(()=>{
        if(location.state && location.state.navLabel)
            set_nav_label(location.state.navLabel)
    },[])


    useEffect(()=>{
        getFestivals();
        swiper.current=new Swiper('.swiper-container',{
            loop:true,
            autoplay: {
                delay: 5000,
            },
        })
        //Loop();
    },[])

    //fetch festivals ------------------------------------------------------
    const getFestivals = async () => {
        try{
            let response = await FestivalData();
            setFestivals(response.data);
            setPreload(false);
        }catch (e) {
            setFailed(true);
        }
    }

     const shuffleArray = (array) => {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
    }

    //build layer ------------------------------------------------------
    const BildLayer = ({data}) => {

        // const result = data.filter(item=>item.cover)
        const result = data
        //const result = data



        return(
            <div className="festival-con">
                {result.map(item=>{
                    return(
                        <>
                            {item.is_featured?
                                <div className="festival-item-single" onClick={()=>{
                                    history.push(`/festival-detail/${item.uid}`,{festival:item})
                                }}
                                >
                                    <img src={item.cover || item.image || "/other/skeleton/slide.jpg"} alt=""/>
                                    <span>{item.title}</span>
                                </div>:
                                <div className="festival-item-dual" onClick={()=>{
                                    history.push(`/festival-detail/${item.uid}`,{festival:item})
                                }}>
                                    <img src={item.cover || item.image || "/other/skeleton/product.jpg"} alt=""/>
                                    <span>{item.title}</span>
                                </div>
                            }
                        </>

                    )
                })}
            </div>
        )

    }

    const { height, width,mobileWidth } = useWindowDimensions();
    const resp = useResp();

    return(
        <>
            {resp?<CampaignDesktop/>:
                <div className="fastival-container page">

                    <div className="customer-header" style={{width:mobileWidth?mobileWidth:document?.getElementById('mobile-sec')?.clientWidth}}>
                        <i style={{right:25}} onClick={()=>{
                            history.goBack();
                        }}
                           className="fa fa-arrow-right"></i>
                        <span>{nav_label?nav_label:"جشنواره ها"}</span>
                    </div>


                    {!preload?<div className="festival-body">
                            {/*<div className="festival-slider">*/}
                            {/*    <div className="swiper-container swiper1">*/}
                            {/*        <div className="swiper-wrapper">*/}
                            {/*            <div className="swiper-slide"><img src="/festival-slider.png"/></div>*/}
                            {/*        </div>*/}
                            {/*    </div>*/}
                            {/*</div>*/}

                            {festivals?
                                // <BildLayer data={festivals} />
                                <div className="festival-new-list">
                                    {festivals.map(f=>{
                                        return(
                                            <div className="festival-new-card" onClick={()=>{
                                                history.push(`/festival-detail/${f.uid}`,{festival:f})
                                            }}>
                                                <img src={f.cover || f.image || "/other/skeleton/product.jpg"} alt=""/>
                                                <div className="festival-new-info">
                                                    <span>{f.title}</span>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                                :null}
                        </div>
                        :<div className="customer-preLoading">
                            {!failed ? <div className="customer-preloading-body">
                                <img src="/svg/pre.gif" alt=""/>
                            </div> : <div className="customer-failed-body">
                                <img src="/svg/failed.svg" alt=""/>
                                <span>اطلاعاتی موجود نیست</span>
                            </div>}
                        </div>}

                    <Nav/>
                </div>
            }
            </>

    )

}

export {Festival};
